import { Modal } from "@tokenterminal/core/ui/overlays/modal/Modal"
import { LoadingSpinner } from "@tokenterminal/core/ui/progress/LoadingSpinner"
import { useMart } from "modules/mart/hooks/useMart"
import { resolveColDefs } from "modules/MartDataGrid/martColumnUtils"
import { useMetricsMeta } from "modules/metrics/hooks/useMeta"
import { Suspense, lazy, useMemo } from "react"
import { type Mart } from "types/ApiTypes"

const MART_SLUG = "crypto-screener"

type MasterExcelModalProps = {
  setIsOpen: (isOpen: boolean) => void
  isOpen: boolean
  onClose: (args?: any) => void
}

const ExportModalContent = lazy(() => {
  return import("./ExportModalContent").then((module) => ({
    default: module.ExportModalContent,
  }))
})

function ModalContent({ onClose }: Pick<MasterExcelModalProps, "onClose">) {
  const mart = useMart(MART_SLUG) as unknown as Mart
  const metricConfigurations = useMetricsMeta()

  const columnDefs = useMemo(
    () =>
      resolveColDefs(
        mart.column_definitions,
        mart.mart_id,
        mart.default_preset,
        metricConfigurations
      ),
    [mart, metricConfigurations]
  )

  return (
    <ExportModalContent
      martId={mart.mart_id}
      columnDefinitions={columnDefs}
      onDownload={(downloadPromise) => {
        downloadPromise.then(() => {
          onClose()
        })
      }}
      cancel={async () => onClose?.()}
    />
  )
}

export function MasterExcelModal({
  setIsOpen,
  isOpen,
  onClose,
}: MasterExcelModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      isDismissable={false}
      isKeyboardDismissDisabled
    >
      <Suspense
        fallback={
          <div className="center-absolute">
            <LoadingSpinner diameter={16} />
          </div>
        }
      >
        <ModalContent onClose={onClose} />
      </Suspense>
    </Modal>
  )
}
